/**
 * "Rate limits & spend caps" — Billing section (ADR-0074).
 * Reconciled from core/middleware/resource-limits.ts (per-IP request limiting →
 * 429, oversized body → 413), per-tenant-quota.ts (MCP rate/spend/token/call
 * axes), and spend-cap.graphql + the SpendCapsPage. Spend-cap alerting is
 * configurable today; the hard read-only stop is finalizing for launch — hedged
 * accordingly.
 */
import type { DocPageContent } from '../types';

export const BILLING_LIMITS_PAGE: DocPageContent = {
  slug: 'billing/limits',
  titleKey: 'docs.billing.limits.title',
  descriptionKey: 'docs.billing.limits.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.billing.limits.lead' },

    { kind: 'heading', level: 2, id: 'rate', textKey: 'docs.billing.limits.rate.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.limits.rate.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.billing.limits.rate.item.requests',
        'docs.billing.limits.rate.item.payload',
        'docs.billing.limits.rate.item.mcp',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.billing.limits.rate.note.title',
      textKey: 'docs.billing.limits.rate.note.body',
    },

    { kind: 'heading', level: 2, id: 'spend', textKey: 'docs.billing.limits.spend.heading' },
    { kind: 'paragraph', textKey: 'docs.billing.limits.spend.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.billing.limits.spend.item.ceiling',
        'docs.billing.limits.spend.item.alerts',
        'docs.billing.limits.spend.item.scope',
      ],
    },
    {
      kind: 'callout',
      tone: 'note',
      titleKey: 'docs.billing.limits.spend.note.title',
      textKey: 'docs.billing.limits.spend.note.body',
    },

    {
      kind: 'heading',
      level: 2,
      id: 'difference',
      textKey: 'docs.billing.limits.difference.heading',
    },
    { kind: 'paragraph', textKey: 'docs.billing.limits.difference.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.billing.limits.next.usage.title',
          textKey: 'docs.billing.limits.next.usage.text',
          to: { docSlug: 'billing/usage' },
        },
        {
          titleKey: 'docs.billing.limits.next.trust.title',
          textKey: 'docs.billing.limits.next.trust.text',
          to: { path: '/trust' },
        },
      ],
    },
  ],
};
